/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Company } from "./Company";
import {
  CompanyFromJSON,
  CompanyFromJSONTyped,
  CompanyToJSON,
  CompanyToJSONTyped,
} from "./Company";
import type { ApiKey } from "./ApiKey";
import {
  ApiKeyFromJSON,
  ApiKeyFromJSONTyped,
  ApiKeyToJSON,
  ApiKeyToJSONTyped,
} from "./ApiKey";
import type { ApiKeyUsageSummary } from "./ApiKeyUsageSummary";
import {
  ApiKeyUsageSummaryFromJSON,
  ApiKeyUsageSummaryFromJSONTyped,
  ApiKeyUsageSummaryToJSON,
  ApiKeyUsageSummaryToJSONTyped,
} from "./ApiKeyUsageSummary";

/**
 *
 * @export
 * @interface ApiKeyWithCompanyAndUsageSummaries
 */
export interface ApiKeyWithCompanyAndUsageSummaries {
  /**
   *
   * @type {ApiKey}
   * @memberof ApiKeyWithCompanyAndUsageSummaries
   */
  apiKey: ApiKey;
  /**
   *
   * @type {Company}
   * @memberof ApiKeyWithCompanyAndUsageSummaries
   */
  company: Company;
  /**
   *
   * @type {Array<ApiKeyUsageSummary>}
   * @memberof ApiKeyWithCompanyAndUsageSummaries
   */
  apiKeyUsageSummaries?: Array<ApiKeyUsageSummary> | null;
}

/**
 * Check if a given object implements the ApiKeyWithCompanyAndUsageSummaries interface.
 */
export function instanceOfApiKeyWithCompanyAndUsageSummaries(
  value: object,
): value is ApiKeyWithCompanyAndUsageSummaries {
  if (!("apiKey" in value) || value["apiKey"] === undefined) return false;
  if (!("company" in value) || value["company"] === undefined) return false;
  return true;
}

export function ApiKeyWithCompanyAndUsageSummariesFromJSON(
  json: any,
): ApiKeyWithCompanyAndUsageSummaries {
  return ApiKeyWithCompanyAndUsageSummariesFromJSONTyped(json, false);
}

export function ApiKeyWithCompanyAndUsageSummariesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiKeyWithCompanyAndUsageSummaries {
  if (json == null) {
    return json;
  }
  return {
    apiKey: ApiKeyFromJSON(json["apiKey"]),
    company: CompanyFromJSON(json["company"]),
    apiKeyUsageSummaries:
      json["apiKeyUsageSummaries"] == null
        ? undefined
        : (json["apiKeyUsageSummaries"] as Array<any>).map(
            ApiKeyUsageSummaryFromJSON,
          ),
  };
}

export function ApiKeyWithCompanyAndUsageSummariesToJSON(
  json: any,
): ApiKeyWithCompanyAndUsageSummaries {
  return ApiKeyWithCompanyAndUsageSummariesToJSONTyped(json, false);
}

export function ApiKeyWithCompanyAndUsageSummariesToJSONTyped(
  value?: ApiKeyWithCompanyAndUsageSummaries | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    apiKey: ApiKeyToJSON(value["apiKey"]),
    company: CompanyToJSON(value["company"]),
    apiKeyUsageSummaries:
      value["apiKeyUsageSummaries"] == null
        ? undefined
        : (value["apiKeyUsageSummaries"] as Array<any>).map(
            ApiKeyUsageSummaryToJSON,
          ),
  };
}
